// extracted by mini-css-extract-plugin
export var tabs = "tabs-module--tabs--0r5Z5";
export var tabItem = "tabs-module--tab-item--Lvd1q";
export var tabLink = "tabs-module--tab-link--AksAC";
export var tabLinkActive = "tabs-module--tab-link-active--aBPth";